import type { BlendModifier } from "./BlendModifier.ts";

export enum ObjectType {
  Empty = 0,
  Mesh = 1,
  Light = 10,
  Camera = 11,
  Armature = 25,
}

export interface BlendObject {
  name: string;
  type: ObjectType;
  parentName: string | null;
  localPosition: [number, number, number];
  localRotation: [number, number, number];
  localScale: [number, number, number];
  parentInverse: number[];
  meshRef: string | null;
  shapeKeySetRef: string | null;
  /** Blender restrictflag — bit 0 = hidden in viewport, bit 2 = hidden in render */
  restrictFlag: number;
  /** True if this object is only in viewport-hidden collections */
  hiddenByCollection: boolean;
  /** Parsed modifiers (mirror, subsurf, solidify) in stack order */
  modifiers: BlendModifier[];
}
